import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { TextLoca } from "../../generic/text/TextLoca";
import { OfferBadgePurchasePoints } from "./OfferBadgePurchasePoints";
import { OfferRemainingTime } from "./OfferRemainingTime";
export var OfferDecoration = function (_a) {
    var locaKeyEyecatcher = _a.locaKeyEyecatcher, imageName = _a.imageName, remainingSeconds = _a.remainingSeconds, purchasePoints = _a.purchasePoints;
    var bannerStyle = {
        background: "url(" + process.env.PUBLIC_URL + "/static/images/shop/" + imageName + ".png) no-repeat center",
        backgroundSize: "cover",
    };
    return (React.createElement("div", { className: "offer-body__decoration" },
        React.createElement("div", { className: "offer-body__title" }, locaKeyEyecatcher && (React.createElement(TextLoca, { className: IdStyles.HeadlineOne, id: locaKeyEyecatcher }))),
        React.createElement("div", { className: IdStyles.OfferBanner + " offer-body__banner", style: bannerStyle },
            React.createElement(OfferBadgePurchasePoints, { purchasePoints: purchasePoints, className: "offer-body__purchase-points-badge" })),
        remainingSeconds && remainingSeconds > 0 && (React.createElement(OfferRemainingTime, { remainingSeconds: remainingSeconds }))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/shop/components/OfferDecoration.tsx
// module id = 2911
// module chunks = 3